// extracted by mini-css-extract-plugin
module.exports = {"formContainer":"Accounts_formContainer__3-csO","formGroup":"Accounts_formGroup__ICyFY","separator":"Accounts_separator__37mFS"};